"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../../comps/reusables");
const graphql_1 = require("../../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const IntegrationSharedSettings_1 = require("../IntegrationSharedSettings");
class MailchimpSettings extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(reusables_1.Form, { mutationProps: {
                mutation: graphql_1.updateMailchimp,
                refetchQueries: [
                    {
                        query: graphql_1.integration,
                        variables: {
                            id: this.props.integration.id,
                        },
                    },
                ],
            }, valuesToVariables: values => {
                return {
                    data: {
                        name: values.name.trim(),
                    },
                    id: this.props.integration.id,
                };
            }, formikProps: {
                initialValues: {
                    name: this.props.integration.name,
                },
                validationSchema: () => Yup.object().shape({
                    name: Yup.string()
                        .trim()
                        .required('Required'),
                }),
            }, showBottomToolbar: true }, formikProps => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(IntegrationSharedSettings_1.IntegrationSharedSettings, { integration: this.props.integration, formikProps: formikProps, hasAccessKey: true })))));
    }
}
exports.MailchimpSettings = MailchimpSettings;
//# sourceMappingURL=MailchimpSettings.js.map